import { useState } from "react";
import CallDialog from "./CallDialog";
import Button from "@/components/base/Button";
import ScrollCue from "@/components/feature/ScrollCue";

export default function Hero() {
  const [callOpen, setCallOpen] = useState(false);

  return (
    <section
      id="hero"
      data-stage="0"
      className="relative min-h-[65vh] w-full flex items-start justify-center overflow-hidden pt-32 md:pt-0"
    >

      <div className="relative z-10 w-full max-w-5xl px-6 md:px-12 text-center">

        <h1
          data-reveal
          data-delay="2"
          className="font-syncopator text-[19vw] sm:text-[16vw] md:text-[8.5rem] lg:text-[10rem] leading-[1.08] md:leading-[0.92] md:pt-[calc(50vh_-_143px)] lg:pt-[calc(50vh_-_165px)] text-black font-light tracking-tightest drop-shadow-[0_4px_24px_rgba(0,0,0,0.35)]"
        >
          Wächst<br className="md:hidden" />
          {' '}Gras schneller,
          <br />
          wenn man<br className="md:hidden" />
          {' '}daran zieht?
        </h1>

        <div
          data-reveal
          data-delay="3"
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Button
            size="lg"
            onClick={() => setCallOpen(true)}
            className="bg-sage text-bg hover:bg-ink"
          >
            Dünger
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </Button>
        </div>

        <div
          data-reveal
          data-delay="4"
          className="mt-28 flex flex-col items-center"
        >
          <ScrollCue
            label="DURCH DAS GRAS LAUFEN"
            labelClassName="text-ink/70 group-hover:text-ink"
            trackClassName="bg-ink/30"
            fillClassName="bg-sage"
            iconClassName="text-ink/60 group-hover:text-ink"
          />
        </div>
      </div>

      <CallDialog open={callOpen} onClose={() => setCallOpen(false)} />
    </section>
  );
}